export default [
  {
    name: 'event',
    path: '/event/setting',
    component: () => import(/* webpackChunkName: "event" */ './Setting'),
    meta: {
      showNavbar: true,
      title: 'Configurações Gerais',
      icon: 'dvr',
      label: 'Configurações',
      permission: 'event.config'
    }
  },
  {
    name: 'authentication',
    path: '/event/authentication',
    component: () => import(/* webpackChunkName: "event" */ './Authentication'),
    meta: {
      showNavbar: true,
      title: 'Meu Evento',
      icon: 'dvr',
      label: 'Autenticação',
      permission: 'event.config'
    }
  },
  {
    name: 'integration',
    path: '/event/integration',
    component: () => import(/* webpackChunkName: "event" */ './Integration'),
    meta: {
      showNavbar: true,
      title: 'Integrações',
      icon: 'dvr',
      label: 'Integrações',
      permission: 'event.config'
    }
  },
  {
    name: 'certificate',
    path: '/event/certificate',
    component: () => import(/* webpackChunkName: "event" */ './Certificate'),
    meta: {
      showNavbar: true,
      title: 'Meu Evento',
      icon: 'dvr',
      label: 'Certificação',
      permission: 'event.config'
    }
  },
  {
    name: 'customization',
    path: '/event/customization',
    component: () => import(/* webpackChunkName: "event" */ './Custom'),
    meta: {
      showNavbar: true,
      title: 'Meu Evento',
      icon: 'dvr',
      label: 'Customização',
      permission: 'event.config'
    }
  },
  {
    name: 'lobby-banners',
    path: '/event/lobby-banners',
    component: () => import(/* webpackChunkName: "event" */ './lobbyBanners/Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Meu Evento',
      icon: 'dvr',
      label: 'Lobby Banners',
      permission: 'event.config'
    }
  },
  {
    name: 'timeline',
    path: '/event/timeline',
    component: () => import(/* webpackChunkName: "event" */ './timelineBanners/Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Meu Evento',
      icon: 'dvr',
      label: 'Timeline',
      permission: 'event.config'
    }
  },
  {
    name: 'indication',
    path: '/event/indication',
    component: () => import(/* webpackChunkName: "event" */ './indication/Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Meu Evento',
      icon: 'dvr',
      label: 'Indicação',
      permission: 'event.config'
    }
  },
  {
    name: 'terms-conditions',
    path: '/event/terms-conditions',
    component: () => import(/* webpackChunkName: "event" */ './Terms'),
    meta: {
      showNavbar: true,
      title: 'Meu Evento',
      icon: 'dvr',
      label: 'Termos e Condições',
      permission: 'event.config'
    }
  }
]
